import { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAuth, useCoy, useFeatures } from "../../contexts/AuthContext";
import { useTabManager } from "../../contexts/tab-manager";
import { Tree } from "../utils/tree";
import { Hide } from "../utils/hide";
import { ShowImage } from "../utils/image";

const SideBar = ({ side = false, setSide = () => { } }) => {
    const auth = useAuth();
    const features = useFeatures();
    const [links, setLinks] = useState([]);
    const tabManager = useTabManager();
    const coy = useCoy();
    useEffect(() => {
        setLinks([...[{ name: "Dashboard", goto: "home", icon: "fas fa-tachometer-alt" }], ...cleanFeature(features)]);
        // eslint-disable-next-line
    }, [features]);
    const cleanFeature = (features) => {
        for (let i = features.length - 1; i > -1; i--) {
            const feature = features[i];
            if (!feature.menu) {
                features.splice(i, 1);
                continue;
            }

            if (!feature.mod) {
                feature.features = feature.features || [];
                for (let j = feature.features.length - 1; j > -1; j--) {
                    let sub = feature.features[j]
                    //remove sub features without list access
                    if (sub.mod && !auth.listAccess(sub.mod)) {
                        feature.features.splice(j, 1);
                        continue;
                    }
                }
                if (!feature.features?.length) {
                    features.splice(i, 1);
                    continue;
                }
            }

            let url = feature.url?.length ? feature.url : `${process.env.PUBLIC_URL}/${feature.name.split(" ").map(str => str.toLowerCase()).join("-")}`;
            feature.goto = url;
            feature.features = feature.features ? cleanFeature(feature.features) : [];
        }
        return features ?? [];
    }

    const renderFeature = (node) => {
        const openTab = (e) => {
            e.preventDefault();
            if (node.features?.length) return;
            tabManager.open({ title: node.name, url: node.goto });
        }
        const RenderIcon = (icon) => {
            if (icon.split(" ") < 2) return
            return <FontAwesomeIcon icon={icon.split(" ")} />
        }
        return <div className="py-1 text-truncate">
            <a onClick={openTab} className={`w-100 text-white text-decoration-none text-nowrap`} title={node.name} href={node.goto}>
                <span className="tree-icon">
                    {RenderIcon(node.icon)}
                </span>

                <Hide state={side}>
                    {node.name}
                </Hide>
            </a>
        </div>
    }

    const icon = (state) => {
        if (state) return <FontAwesomeIcon icon={['fas', "fa-chevron-right"]} />;
        return <FontAwesomeIcon icon={['fas', "fa-chevron-left"]} />
    }

    const toggleSide = () => {
        setSide(!side);
    }
    return (<nav className={`navbar navbar-dark align-items-start sidebar sidebar-dark accordion bg-gradient-primary p-0${side ? " toggled" : ""}`}>
        <div className="container-fluid d-flex flex-column p-0">
            <a className="navbar-brand m-0" href="./">
                <ShowImage src={coy.photo} domain={coy.domain} className="rounded img-fluid px-4 " />
            </a>
            <hr className="sidebar-divider my-2" />
            <div className="w-100 text-light">
                <Tree nodes={links} nrender={renderFeature} childKey={"features"} active={false} />
            </div>
            <div className="text-center d-none d-md-inline">
                <button onClick={toggleSide} className="btn btn-light rounded-circle border-0" type="button">
                    {icon(side)}
                </button>
            </div>
        </div>
    </nav>);
}

export default SideBar;